<template lang="html">
  <v-dialog v-model="scheduleOrdersModal" scrollable full-width max-width='500'>
    <v-card class="pa-0">
      <v-card-title class="pt-4 pb-3">
        <v-flex>
          <h6>
            Pedidos
          </h6>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right ">
          <v-btn class="ma-0" icon @click.native="scheduleOrdersModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <!-- <v-flex xs12>
          <div class="input-box mt-3 mb-3">
            <v-icon class="mr-2">search</v-icon>
            <input v-model="pesquisar" type="text" name="" value="" placeholder="Procurar">
          </div>
        </v-flex> -->
      </v-card-title>
      <v-card-text class="pa-3" v-if="orders.length > -1" style="max-height:468px;">
        <order v-for="order in orders" :value="order" :key="order.id" @details="details($event)"></order>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import order from '@/components/painel/sharedComponents/order/'
export default {
  name: 'orders-list',
  components: {
    'order': order
  },
  data () {
    return {
      pesquisar: ''
    }
  },
  computed: {
    scheduleOrdersModal: {
      get () {
        return this.$store.getters.scheduleOrdersModal
      },
      set () {
        this.$store.commit('toggleScheduleOrdersModal', false)
      }
    },
    orders () {
      return this.$store.getters.registeredScheduleOrders
    }
  }
}
</script>

<style lang="css">
.input-box{
  border: 1px solid #d9d9d9;
  border-radius: 15px;
  padding: 8px;
  position: relative;
}
.input-box input {
    position: absolute;
    outline: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    padding-left: 37px;
    font-size: 22px;
    color: #5a5a5a;
}
</style>



// WEBPACK FOOTER //
// OrdersList.vue?13e131f8